import React from 'react'
import styled from 'styled-components'
import { textSize, Text } from 'lib/Text'

const LeftArrow = styled(Text)`
  margin-right: 0px;
  transition: margin-right 0.2s ease-in-out;
`

const Button = styled.button`
  ${textSize('p')}
  appearance: none;
  background: none;
  border: none;
  padding: none;
  cursor: pointer;
  color: var(--neutral-100);

  &:hover ${LeftArrow} {
    margin-right: 4px;
  }
`

interface Props {
  onClick?: () => void
}
export const BackButton = ({ onClick }: Props) => {
  return (
    <Button onClick={onClick}>
      <LeftArrow size="m" as="span">
        &larr;
      </LeftArrow>{' '}
      Back
    </Button>
  )
}
